import classes from './DisplayModePicker.module.css';
import OptionTilePicker from './OptionTilePicker';

// Where each mode puts the block, drawn rather than described. The five
// sentences this replaces said the same thing in prose — "typically display in
// the center of your website", "sits either on top of your site, or at the
// bottom" — which is a spatial fact a 108px picture carries better, and which
// cost five lines above every other control on the tab.
//
// The sentences are not thrown away: each is the tile's tooltip, so the
// wording an author may have learned the modes by is still a hover away.
const MODES = [
  {
    value: 'static',
    label: 'Static',
    hint: 'Placed at a specific spot on the page and displayed all the time.',
    // In the flow of the page, between its content, rather than over it.
    block: { left: '14%', right: '14%', top: '40%', height: '26%' },
  },
  {
    value: 'popup',
    label: 'Pop-up',
    hint: 'A lightbox in the centre of the page, over a dimmed background. The most attention it can ask for.',
    overlay: true,
    block: { left: '22%', right: '22%', top: '28%', bottom: '22%' },
  },
  {
    value: 'flyout',
    label: 'Flyout',
    hint: 'Slides into a bottom corner. More subtle than a pop-up, and more noticeable than something in the page.',
    block: { right: '8%', bottom: '8%', width: '36%', height: '34%' },
  },
  {
    value: 'bar',
    label: 'Bar',
    hint: 'A full-width strip across the top or the bottom of the page.',
    block: { left: 0, right: 0, top: '8px', height: '20%' },
  },
  {
    value: 'custom',
    label: 'Custom',
    hint: 'Your own integration decides where this block goes and what it looks like.',
    outline: true,
    block: { left: '22%', right: '22%', top: '30%', bottom: '24%' },
  },
];

// The drawing for one mode: a page, with the block where that mode puts it.
const glyph = (mode) => (
  <div className={classes.viewport}>
    <div className={classes.chrome}>
      <span className={classes.dot} />
      <span className={classes.dot} />
      <span className={classes.dot} />
    </div>
    <div className={classes.line} />
    <div className={classes.line} style={{ marginRight: '40%' }} />
    <div className={classes.line} />
    {mode.overlay && <div className={classes.overlay} />}
    <div className={classes.block} style={mode.block} data-outline={mode.outline || undefined} />
  </div>
);

const DisplayModePicker = ({ value, onChange }) => (
  <OptionTilePicker
    label="Display mode"
    value={value}
    onChange={onChange}
    options={MODES.map((mode) => ({ ...mode, glyph: glyph(mode) }))}
  />
);

export default DisplayModePicker;
